import FetchFactory, {
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";

import {
	EditOrganisationInfo,
	OrganisationInfo,
	OrganisationOverview
} from "./OrganisationTypes";

const ENDPOINT = "/api/organisations";

export default class OrganisationClient {
	public static getAll(): GetRequest<Array<OrganisationOverview>> {
		return FetchFactory.get(ENDPOINT);
	}

	public static create(
		data: EditOrganisationInfo
	): ModifyRequest<EditOrganisationInfo, OrganisationInfo> {
		return FetchFactory.post(ENDPOINT, data);
	}

	public static get(id: number): GetRequest<OrganisationInfo> {
		return FetchFactory.get(`${ENDPOINT}/${id}`);
	}

	public static update(
		id: number,
		data: EditOrganisationInfo
	): ModifyRequest<EditOrganisationInfo, OrganisationInfo> {
		return FetchFactory.put(`${ENDPOINT}/${id}`, data);
	}
}
